import { useMemo } from 'react';

import styles from './styles.module.css';
import {
  TableRow,
  createSequenceColumns,
  createGeneratorColumns,
  createControlSystemColumns,
  createSequenceRows,
  createGeneratorRows,
  createControlSystemRows,
  StatusIndicatorWithStyles
} from './utils';
import DataTable from '@/components/DataTable';
import EmptyState from '@/components/EmptyState';
import GridContainer from '@/components/GridContainer';
import { getControlPath } from '@/solaris-lens-common-lib/src/utils/turbinesPaths';

const sequenceColumns = createSequenceColumns(StatusIndicatorWithStyles);
const generatorColumns = createGeneratorColumns(StatusIndicatorWithStyles);
const controlSystemColumns = createControlSystemColumns(
  StatusIndicatorWithStyles
);

export default function ControlTab({ turbineData }: { turbineData: any }) {
  const initialData = useMemo(() => {
    if (turbineData) {
      return getControlPath(turbineData) || {};
    }
    return {};
  }, [turbineData]);

  const sequenceRows: TableRow[] = useMemo(
    () => createSequenceRows(initialData),
    [initialData]
  );

  const generatorRows: TableRow[] = useMemo(
    () => createGeneratorRows(initialData),
    [initialData]
  );

  const controlSystemRows: TableRow[] = useMemo(
    () => createControlSystemRows(initialData),
    [initialData]
  );

  const hasData =
    sequenceRows.length > 0 ||
    generatorRows.length > 0 ||
    controlSystemRows.length > 0;

  if (!hasData) {
    return (
      <EmptyState
        title="No data available"
        subtitle="No data available for this tab."
      />
    );
  }

  return (
    <GridContainer gap="30px" independentHeight align="none">
      {sequenceRows.length > 0 && (
        <DataTable
          rows={sequenceRows}
          columns={sequenceColumns}
          title="SEQUENCE"
          type="detail"
          getRowId={row => row.key}
          noLeftMargin={true}
          alignTextLeft={true}
          className={styles.controlTable}
        />
      )}
      {generatorRows.length > 0 && (
        <DataTable
          rows={generatorRows}
          columns={generatorColumns}
          title="GENERATOR"
          type="detail"
          getRowId={row => row.key}
          noLeftMargin={true}
          alignTextLeft={true}
          className={styles.controlTable}
        />
      )}
      {controlSystemRows.length > 0 && (
        <DataTable
          rows={controlSystemRows}
          columns={controlSystemColumns}
          title="CONTROL SYSTEM"
          type="detail"
          getRowId={row => row.key}
          noLeftMargin={true}
          alignTextLeft={true}
          className={styles.controlTable}
        />
      )}
    </GridContainer>
  );
}
